/** Opt-in instant fields display browser-local wall time and persist an explicit UTC offset. */
export function instantInputValue(value: unknown): string {
    const text = String(value ?? '')
    if (!text || !/(Z|[+-]\d\d:\d\d)$/i.test(text)) return text
    const date = new Date(text)
    if (!Number.isFinite(date.getTime())) return text
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export function instantStoredValue(value: unknown): string {
    const text = String(value ?? '')
    if (!text) return ''
    const date = new Date(text)
    if (!Number.isFinite(date.getTime())) return text
    if (!/(Z|[+-]\d\d:\d\d)$/i.test(text) && instantInputValue(date.toISOString()) !== text.slice(0, 16)) return text
    return date.toISOString()
}
